<template>
  <v-card>
    <v-list dense>
      <v-list-item @click="dialog = !dialog">
        <v-list-item-content>Price in {{ currency.name }}:</v-list-item-content>
        <v-list-item-content class="align-end">
          {{ model.type == "upcharge" ? "+" + model.price : model.price }}
          {{ currency.currency }}
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field v-model="model.price" label="Price" :prefix="currency.currency"></v-text-field>
                </v-flex>
                <v-flex xs12 md12 v-if="!assembled">
                  <v-select :items="types" label="Price Type" v-model="model.type"></v-select>
                </v-flex>
                <v-flex xs12 md12>
                  <v-checkbox :items="types" label="VAT Included" v-model="model.includeVat" :false-value="0" :true-value="1"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel()">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data : () => ({
    model:{},
    dialog: null,
    valid: null,
    types: [
      { value: "fix", text: "Fix price" },
      { value: "upcharge", text: "Upcharge" }
    ]
  }),
  props: {
    productId:{
      type: Number,
      required:true
    },
    productPrice:{
      type:Object,
      default: () => ({
        price: 0,
        includeVat: 0,
      })
    },
    catalogId: {
      type: Number
    },
    currency:{
      type:Object,
      required:true
    },
    assembled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.model = this.productPrice;
  },
  watch: {
    productPrice(){
      this.model = this.productPrice;
    }
  },
  methods: {
    ...mapActions("products", ["updatePrice"]),
    save() {
      if (this.$refs.form.validate()) {
        if(!this.model.productId)
          this.model.productId = this.productId;
        if(!this.model.catalog_id)
          this.model.catalog_id = this.catalogId;
        if(!this.model.currency)
          this.model.currency = this.currency.currency;
        if(!this.model.type && this.assembled){
          this.model.type = 'assembled'
        }
        
        this.updatePrice({
            model: this.model
          })
          .then(data => {
            this.model = data.productPrice;
          })
          .finally(() => (this.dialog = false));
      }
    },
    cancel() {
      this.dialog = false;
    }
  }
};
</script>

<style></style>
